import { $UserAddPermissions, ACTIONS } from "@store/user-store";
import {
  useCreateDocumentTemplatesGroupMutation,
  useDeleteDocumentTemplatesGroupMutation,
  useUpdateDocumentTemplatesGroupMutation,
} from "@lib/document-templates";

import React from "react";
import { TextField } from "@mui/material";
import useModal from "@modals/modal-hook";
import { useUnit } from "effector-react";
import useStyles from "@ui/material-ui-styles";

const CreateDocumentTemplatesGroupModal: React.FC = () => {
  const { modalComponent, modalData, close } = useModal();
  const classes = useStyles();
  const permissions = useUnit($UserAddPermissions);

  const createDocumentTemplatesGroupMutation =
    useCreateDocumentTemplatesGroupMutation();
  const updateDocumentTemplatesGroupMutation =
    useUpdateDocumentTemplatesGroupMutation();
  const deleteDocumentTemplatesGroupMutation =
    useDeleteDocumentTemplatesGroupMutation();

  const handleSubmit = (e: any) => {
    e.preventDefault();
    const modalBtn = document.querySelector(
      "button.modal_btn"
    ) as HTMLButtonElement;
    modalBtn.disabled = true;

    const groupTitle = document.querySelector(
      'input[name="groupTitle"]'
    ) as HTMLInputElement;

    // CREATING NEW GROUP
    if (groupTitle?.value && !modalData.editMode) {
      createDocumentTemplatesGroupMutation.mutate(
        {
          name: groupTitle.value,
        },
        {
          onSuccess: () => {
            close();

            if (modalData.onConfirm) {
              modalData.onConfirm();
            }
          },
        }
      );
    }

    if (groupTitle?.value && modalData.editMode) {
      updateDocumentTemplatesGroupMutation.mutate(
        {
          id: modalData.groupId,
          name: groupTitle.value,
        },
        {
          onSuccess: () => {
            close();
          },
        }
      );
    }
  };

  const handleDelete = () => {
    if (typeof modalData.groupId !== "number") return;

    deleteDocumentTemplatesGroupMutation.mutate(
      {
        id: modalData.groupId,
      },
      {
        onSuccess: () => {
          close();
        },
      }
    );
  };

  return (
    <div key={modalComponent.key}>
      <p className="modal_title">{modalData.modalTitle}</p>
      <div className="underline" />
      <form className={`modal_content ${classes.root}`} onSubmit={handleSubmit}>
        <TextField
          label={"Название группы"}
          name={"groupTitle"}
          variant="filled"
          required
          defaultValue={modalData.itemTitle}
        />
        {modalData.editMode ? (
          <div className="modal_buttons_group">
            <button type="submit" className="modal_btn">
              {modalComponent.btnText}
            </button>
            {permissions.hasPermission(
              ACTIONS.companyDocumentTemplates_groups_allowedToDelete
            ) && (
              <button
                type="button"
                className="modal_btn"
                onClick={handleDelete}
              >
                Удалить
              </button>
            )}
          </div>
        ) : (
          <button type="submit" className="modal_btn">
            {modalComponent.btnText}
          </button>
        )}
      </form>
    </div>
  );
};

export default CreateDocumentTemplatesGroupModal;
